import React from 'react';
import styles from '../styles/Service.module.css';

function Service() {
    const services = [
        {
            id: "01",
            title: "ゲーム制作支援",
            description: "コンソールゲームからスマホゲームまで、CGアセットを動かすプロジェクトを広く支援しています。\n技術検証（R&D）や仕様策定といった最上流工程からの参画はもちろん、スピードと精度が求められる量産フェーズまで、プロジェクトの状況に合わせた柔軟な体制構築が可能です。",
        },
        {
            id: "02",
            title: "アニメCGアセット制作支援",
            description: "セルルックCGアニメに特化した強みを持ち、TVシリーズや遊技機などの豊富な実績を有しています。\n標準的な人型キャラクターから、複雑な骨格を持つ4足歩行のクリーチャーまで。作品の個性に合わせた最適なリギングを提供します。",
        },
        {
            id: "03",
            title: "広告／MV用CG制作支援",
            description: "リギングを核としつつ、モーション制作まで一貫してサポートします。\n映像のコンセプトを深く理解し、予算と納期に合わせた品質を提案します。"
        },
    ];

    return (
        <section className={styles.container}>
            <h2 className={styles.title}>SERVICE</h2>
            <div className={styles.serviceList}>
                {services.map((service, index) => (
                    <div key={index} className={styles.serviceItem}>
                        <div className={styles.itemHeader}>
                            <span className={styles.itemNumber}>SVC: {service.id}</span>
                            <div className={styles.headerLine}></div>
                        </div>
                        <h3 className={styles.serviceTitle}>{service.title}</h3>
                        <p className={styles.serviceDescription}>
                            {service.description.split('\n').map((line, i) => (
                                <React.Fragment key={i}>
                                    {line}
                                    {i !== service.description.split('\n').length - 1 && <br />}
                                </React.Fragment>
                            ))}
                        </p>

                        {/* 装飾用コーナーブラケット (四隅) */}
                        <div className={styles.cornerTL}></div>
                        <div className={styles.cornerTR}></div>
                        <div className={styles.cornerBL}></div>
                        <div className={styles.cornerBR}></div>
                    </div>
                ))}
            </div>
        </section>
    );
}

export default Service;
